module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-07.1d8de988.svg";